import { FaReact, FaBootstrap, FaJsSquare } from 'react-icons/fa'
import { DiGit, DiIonic, DiMysql, DiVisualstudio } from 'react-icons/di'
import { SiAdobexd, SiNodedotjs, SiExpress, SiDocker } from 'react-icons/si'
const projects = [
  {
    id: 1,
    image:
      'https://user-images.githubusercontent.com/66588352/141417597-c2efee5a-e164-4677-9899-8b11d2b167f0.png',
    title: 'The Universal Auth System',
    desc: 'Universal Auth System Made With Mysql, Express, React, Node',
    tools: [
      { id: 1, name: 'Mysql' },
      { id: 2, name: 'Express' },
      { id: 3, name: 'React' },
      { id: 4, name: 'Nodejs' },
      { id: 5, name: 'BootStrap' },
    ],

    link: 'https://github.com/mahmoud-bebars/UA-MERN',
  },

  {
    id: 2,
    image:
      'https://user-images.githubusercontent.com/66588352/141427880-97861f54-1b92-4a21-8854-1e456f37cb9c.png',
    title: 'Nodejs News App ',
    desc: 'This Web app provides a news from the Public News Api',
    tools: [
      { id: 1, name: 'Nodejs' },
      { id: 2, name: 'Express' },
      { id: 3, name: 'BootStrap 5' },
      { id: 4, name: 'EJS Templete' },
      { id: 5, name: 'Axios' },
      { id: 6, name: 'Nodemon' },
    ],

    link: 'https://github.com/mahmoud-bebars/Nodejs-News',
  },
  {
    id: 3,
    image:
      'https://user-images.githubusercontent.com/66588352/141428835-833078e3-1047-4770-b7c8-212a5a82a490.png',
    title: 'Simple nodejs Rest api',
    desc: 'simple project represent a simple api with a GET method reteriving info about programming languages from a local database',
    tools: [
      { id: 1, name: 'Nodejs' },
      { id: 2, name: 'Express' },
      { id: 3, name: 'Mysql' },
    ],

    link: 'https://github.com/mahmoud-bebars/nodejs-mysql-api-sample',
  },
]

const frontSkills = [
  { id: 1, icon: <FaReact />, name: 'React.js' },
  { id: 2, icon: <FaBootstrap />, name: 'BootStrap 5' },
  { id: 3, icon: <FaJsSquare />, name: 'EJS' },
]
const backSkills = [
  { id: 1, icon: <SiNodedotjs />, name: 'Node.js' },
  { id: 2, icon: <SiExpress />, name: 'Express.js' },
  { id: 3, icon: <DiMysql />, name: 'Mysql' },
  { id: 4, icon: <SiDocker />, name: 'Docker' },
]
const ToolsTechs = [
  { id: 1, icon: <DiVisualstudio />, name: 'Visual studio Code' },
  { id: 2, icon: <DiGit />, name: 'Git Version Control' },
  { id: 3, icon: <DiIonic />, name: 'Post Man' },
  { id: 4, icon: <SiAdobexd />, name: 'Adobe xd' },
]
export { projects, frontSkills, backSkills, ToolsTechs }
